import { render, staticRenderFns } from "./invalidRule.vue?vue&type=template&id=ed06f51c&scoped=true&"
import script from "./invalidRule.vue?vue&type=script&lang=js&"
export * from "./invalidRule.vue?vue&type=script&lang=js&"
import style0 from "./invalidRule.vue?vue&type=style&index=0&id=ed06f51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed06f51c",
  null
  
)

export default component.exports